/** Dependencies */
import angular from 'angular';
/** Methods */
import { KpsPaymentDialogService, kpsPayComponent } from './dom/kpsPaymentDialog/kpsPaymentDialog';
import { openedgePaymentDialogDirective } from './dom/openedgePaymentDialog/openedgePaymentDialog';
import { pacePaymentDialogDirective } from './dom/pacePaymentDialog/pacePaymentDialog';
import { paymentCardDialogComponent } from './dom/paymentCardDialog/paymentCardDialog';
import { paypalExpressCheckoutComponent } from './dom/paypalExpressCheckout/paypalExpressCheckout';


/*******************************************************************************
 * @ngdoc  overview
 * @module csm.payments
 * @description
 * Payments API client side components.
 *******************************************************************************/
export default angular
  .module('csm.payments.dom', ['CSMCommonWeb'])
  .service('KpsPaymentDialog', KpsPaymentDialogService)
  .component('kpsPay', kpsPayComponent)
  .directive('openedgePaymentDialog', openedgePaymentDialogDirective) 
  .directive('pacePaymentDialog', pacePaymentDialogDirective)
  .component('paymentCardDialog', paymentCardDialogComponent) 
  .component('paypalExpressCheckout', paypalExpressCheckoutComponent)
  .name;
